<template>
    <div class="folder-details-container">
        <FolderDetailsComponent />

        <!-- <div class="file-uploader-container">
            
            <FileUploadSteps 
                :folderId="this.$route.params.id"
            />
        </div> -->
    </div>
</template>

<script>
import FileUploadSteps from '@/components/app/file_upload_components/FileUploadSteps.vue'
import FolderDetailsComponent from '@/components/app/folder_details_components/FolderDetailsComponent.vue';

export default {
    components: {
        FileUploadSteps,
        FolderDetailsComponent
    }

}
</script>

<style lang="scss" scoped>
    .folder-details-container {
        max-width: 1000px;
        margin: auto;
    }
</style>
